import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const TS = '/hanh-chinh/tai-san'
const TLTS = '/hanh-chinh/tai-lieu-tai-san'
const BTS = '/hanh-chinh/bao-tri-tai-san'

// Lọc danh sách tài sản (chấp nhận query string hoặc object)
export function locTaiSan(params?: string | Record<string, unknown>) {
  try {
    const query = typeof params === 'string' ? queryString.parse(params) : (params || {})
    return axiosApi.get(`${TS}/loc-danh-sach`, { params: query })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết tài sản
export function layChiTietTaiSan(assetId: number) {
  try {
    return axiosApi.get(`${TS}/${assetId}/chi-tiet`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Quét QR Code tài sản
export function quetQRCodeTaiSan(params: any) {
  try {
    return axiosApi.post(`${TS}/quet-qr`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo tài sản mới
export function taoTaiSan(params: any) {
  try {
    return axiosApi.post(`${TS}/tao`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật tài sản
export function capNhatTaiSan(assetId: number, params: any) {
  try {
    return axiosApi.put(`${TS}/${assetId}/cap-nhat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa tài sản
export function xoaTaiSan(assetId: number) {
  try {
    return axiosApi.delete(`${TS}/${assetId}/xoa`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách tài liệu tài sản
export function layDanhSachTaiLieuTaiSan(assetId: number) {
  try {
    return axiosApi.get(`${TLTS}/${assetId}/danh-sach`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách lịch bảo trì tài sản
export function layDanhSachLichBaoTriTaiSan(assetId: number) {
  try {
    return axiosApi.get(`${BTS}/${assetId}/danh-sach`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo QR Code cho tài sản
export function taoQRCodeTaiSan(assetId: number) {
  try {
    return axiosApi.post(`${TS}/${assetId}/tao-qr`, {})
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy thống kê tài sản
export function layThongKeTaiSan() {
  try {
    return axiosApi.get(`${TS}/tong-quan/thong-ke`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
